import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bankList: [],
  loading: false,
  error: null,
};

const bankListSlice = createSlice({
  name: "bankList", // ✅ final name
  initialState,
  reducers: {
    fetchBankList: (state) => {
      state.loading = true;
    },
    fetchBankListSuccess: (state, action) => {
      state.loading = false;
      state.bankList = action.payload;
    },
    fetchBankListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchBankList, fetchBankListSuccess, fetchBankListFailure } =
  bankListSlice.actions;

export default bankListSlice.reducer;
